import React from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import { withRedux } from "helpers";

const PublicRoute = ({ component: Component, path }) => {
  let location = useLocation();

  // if (window.drift && window.drift.api) {
  //   window.drift.api.widget.hide();
  //   window.drift = undefined;
  // }

  // if (window.drift && window.drift.api) {
  //   window.drift.api.widget.hide();
  // }

  return <Route path={path} render={(props) => <Component {...props} />} />;
};

export default withRedux(PublicRoute);
